<ng-container *transloco="let t">
<ng-template #consent>
  <div id="abad-consent-main" class="container">
    <div class="card">
      <div class="card-body fs-6 p-6 p-lg-15">
        @if (showAbadVerbiage) {
          <div id="abadConsentContainer" [innerHtml]="abadText | safeHtml"></div>
        }
        <div class="py-6">
          <div class="col-lg-12 fv-row mb-6">
            <div class="d-flex flex-column mt-3">
              <label class="form-check form-check-inline form-check-solid mb-3">
                <input class="form-check-input" required name="abadAcknowledged" type="checkbox"
                  [(ngModel)]="abadAcknowledged" />
                <span class="fw-bold ps-2 fs-6 required">{{ t('wizard.abad.iWeAcknowledge') }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<wizard-step-template [stepMainTemplate]="consent" [step]="step" [stepComponent]="this"></wizard-step-template>
</ng-container>
